<template>
  <div>
    <div v-if="$q.screen.gt.sm">
      <q-tabs v-if="menu.length" indicator-color="white">
        <q-route-tab
          v-for="item in menu"
          :key="item.title"
          no-caps
          :to="{ name: 'page', params: { slug: item.page.slug.current } }"
        >
          {{ item.title }}
        </q-route-tab>
      </q-tabs>
    </div>
    <q-btn v-else :icon="sharpMenu" size="lg" unelevated>
      <q-menu>
        <q-card class="bg-white">
          <q-card-section>
            <q-list>
              <q-item
                v-for="item in menu"
                clickable
                active-class="text-underline text-dark"
                class="text-primary"
                :key="item.title"
                :to="{ name: 'page', params: { slug: item.page.slug.current } }"
              >
                <q-item-label>
                  {{ item.title }}
                </q-item-label>
              </q-item>
            </q-list>
          </q-card-section>
        </q-card>
      </q-menu>
    </q-btn>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useSettingsStore } from 'src/stores/settings'
import { sharpMenu } from '@quasar/extras/material-icons-sharp'

defineOptions({ name: 'HeaderMenu' })

const settingsStore = useSettingsStore()
const { menu } = storeToRefs(settingsStore)
</script>
